<template>
  <span>
    <span v-if="!menu" class="action"> 
      <button v-if="buttonType" class="danger delete_button"  @click.prevent="openUnshareModal" >
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.22396 14.2083H10.0052C10.1088 14.2083 10.2082 14.1671 10.2814 14.0939C10.3547 14.0206 10.3958 13.9213 10.3958 13.8177V6.78642C10.3958 6.68282 10.3547 6.58346 10.2814 6.5102C10.2082 6.43695 10.1088 6.39579 10.0052 6.39579H9.22396C9.12036 6.39579 9.021 6.43695 8.94774 6.5102C8.87449 6.58346 8.83333 6.68282 8.83333 6.78642V13.8177C8.83333 13.9213 8.87449 14.0206 8.94774 14.0939C9.021 14.1671 9.12036 14.2083 9.22396 14.2083ZM14.5625 3.27079H11.8799L10.7731 1.42509C10.6342 1.19365 10.4377 1.00214 10.2028 0.869216C9.96789 0.736295 9.70254 0.666498 9.43262 0.666626H6.15072C5.88091 0.66661 5.61569 0.736461 5.38089 0.869377C5.14609 1.00229 4.94971 1.19374 4.81087 1.42509L3.70345 3.27079H1.02083C0.8827 3.27079 0.750224 3.32567 0.652549 3.42334C0.554873 3.52102 0.5 3.65349 0.5 3.79163L0.5 4.31246C0.5 4.45059 0.554873 4.58307 0.652549 4.68074C0.750224 4.77842 0.8827 4.83329 1.02083 4.83329H1.54167V15.7708C1.54167 16.1852 1.70629 16.5826 1.99931 16.8756C2.29234 17.1687 2.68977 17.3333 3.10417 17.3333H12.4792C12.8936 17.3333 13.291 17.1687 13.584 16.8756C13.877 16.5826 14.0417 16.1852 14.0417 15.7708V4.83329H14.5625C14.7006 4.83329 14.8331 4.77842 14.9308 4.68074C15.0285 4.58307 15.0833 4.45059 15.0833 4.31246V3.79163C15.0833 3.65349 15.0285 3.52102 14.9308 3.42334C14.8331 3.32567 14.7006 3.27079 14.5625 3.27079ZM6.09375 2.32385C6.11116 2.29488 6.13579 2.27092 6.16523 2.25431C6.19467 2.23771 6.22792 2.22903 6.26172 2.22913H9.32161C9.35536 2.22909 9.38854 2.23779 9.41792 2.25439C9.4473 2.271 9.47188 2.29493 9.48926 2.32385L10.0576 3.27079H5.52572L6.09375 2.32385ZM12.4792 15.7708H3.10417V4.83329H12.4792V15.7708ZM5.57812 14.2083H6.35938C6.46298 14.2083 6.56233 14.1671 6.63559 14.0939C6.70884 14.0206 6.75 13.9213 6.75 13.8177V6.78642C6.75 6.68282 6.70884 6.58346 6.63559 6.5102C6.56233 6.43695 6.46298 6.39579 6.35938 6.39579H5.57812C5.47452 6.39579 5.37517 6.43695 5.30191 6.5102C5.22865 6.58346 5.1875 6.68282 5.1875 6.78642V13.8177C5.1875 13.9213 5.22865 14.0206 5.30191 14.0939C5.37517 14.1671 5.47452 14.2083 5.57812 14.2083Z" fill="#ffffff"/>
        </svg>
      </button>
      <i  v-if="!buttonType"  @click.stop="openUnshareModal" class="delete-icon fal fa-trash"></i><span class="label">{{unshareLabel}}</span>
    </span>
    <span v-if="menu"
      @click.stop="openUnshareModal"
    > 
      <i   class="delete-icon fal fa-strikethrough"></i><span class="">{{unshareLabel}}</span>
    </span>
    <div :class="[{ open: unshareModalStatus }, 'modal', 'confirmation-modal']">
      <div class="shadow" @click="closeUnshareModal"></div>
      <div class="body">
        <i class="fal fa-times exit" @click="closeUnshareModal"></i>
          <div >
            <div class="heading">Are you sure you want to unshare this?</div>
            <div class="actions">
              <div class="left">
                <button class="secondary" @click.prevent="closeUnshareModal">Cancel</button>
              </div>
              <div class="right">
                  <button class="primary" @click.prevent="doUnshare">Confirm</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import RallyPaginationMixin from "../components/RallyPaginationMixin";  
import {findDefaultChannelObjOfType} from "../common";
import { eventBus } from "../main.js";
  export default {
    mixins: [RallyPaginationMixin],
    props: ['content', 'rallyId', 'channelId', 'shareId', 'menu', 'type'],
    data: function() {
      return {
        unshareModalStatus: false,
        isLoading: true,
        step: 1,
        cbChanges:[],
        page: 1
      };
    },
    created () {

    },
    computed: {
      ...mapState("rallies", ["allRallies", "rallyChannelsByRallyId", "ralliesByParent", "allRalliesByRallyId"]),
      ...mapState("shares", ["sharesByContentId"]),
      buttonType(){
        return this.type == 'button'
      },
      unshareLabel(){
        if (this.menu){
          return "Unshare"
        } else {
          return ""
        }
      }
    },
    methods: {
      ...mapActions("contents", ["clearContentItemFromContexts"]),
      ...mapActions("shares", ["clearShareState", "deleteShare"]),
      async doUnshare() {
        await this.deleteShare({ id: this.shareId, rallyId: this.rallyId });
        //this.clearContentItemFromContexts({ id: this.content.id });
        //this.closeUnshareModal()
        window.location.href = "/" + this.rallyId
        //eventBus.$emit('navUp')
        //this.$emit('perform', 'handleLightboxHide')
        
      },
      closeUnshareModal() {
        this.unshareModalStatus = false;
      },
      openUnshareModal() {
        this.unshareModalStatus = true;
      }
    }
  }
</script>
